import { connect } from 'react-redux';

import { getPublishRulesTree } from 'PublishRulesPackage/MainModule/selectors/publishRulesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './PublishRulesTree.module.scss';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { PublishRulesTreeItem } from './PublishRulesTreeItem';

interface IPublishRulesTreeProps {
  tree: IPublishRulesTreeItem[];
}

const PublishRulesTreeWithoutStore = ({ tree }: IPublishRulesTreeProps) => {
  const renderTree = () => {
    return tree.map((item, index) => (
      <PublishRulesTreeItem key={`publish-rules-tree-item-${index}`} item={item} level={0} />
    ));
  };

  return <div className={styles.Wrapper}>{renderTree()}</div>;
};

const mapStateToProps = (state: IRootState) => ({
  tree: getPublishRulesTree(state),
});

export const PublishRulesTree = connect(mapStateToProps)(PublishRulesTreeWithoutStore);
